import ReactGA from 'react-ga4';

import CookieConsent, { resetCookieConsentValue } from "react-cookie-consent";
// console.log(resetCookieConsentValue());

// Check if we're in an iframe
const isInIframe = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};

// Check if analytics consent has been given
export const hasAnalyticsConsent = () => {
    // Never track in iframes
    if (isInIframe()) return false;

    try {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) return false;

        try {
            const parsed = JSON.parse(consent);
            return parsed.preferences?.analytics === true;
        } catch (e) {
            // Handle old format from react-cookie-consent
            return consent === 'granted';
        }
    } catch (e) {
        // localStorage access failed (private browsing, disabled, etc.)
        console.warn('Unable to access localStorage for consent check:', e);
        return false;
    }
};

export const GAPurchase = (transactionId, value, currency = "USD", items = [{name: "Platform Credits"}]) => {
    if (!hasAnalyticsConsent()) return;

    ReactGA.event('purchase', {
        transaction_id: transactionId,
        value: value, // Revenue value in dollars
        currency: currency, // Currency code, e.g., 'USD'
        items: items // Array of items purchased
    });
};

export const GATrackPlatformClick = (platform = 'facebook') => {
    if (!hasAnalyticsConsent()) return;

    ReactGA.event({
        category: 'Social Links',
        action: 'Click',
        label: platform,
    });
};

export const GAEvent = (...args) => {
    if (!hasAnalyticsConsent()) return;

    ReactGA.event(...args);
};